import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import * as actions from 'data/redux/actions'

import { LoadingIndicator } from 'basecomps'
import { useUser } from 'data/hooks'


export const AppLoader = ({loaded}) => {

  const dispatch = useDispatch()

  useEffect(() => {

    Promise.all([
      dispatch(actions.uiSendEventToAWS({
        action: 'start'
      })),
      dispatch(actions.uiMenusLoad()),
    ])
    .then(() => {
      if (loaded) loaded(true)
    })

  }, [])

  return <LoadingIndicator text="Cargando ..." />
}
